import { MovieOpenEditIcon } from './MovieOpenEditIcon';

/**
 * author: Colton Wiscombe
 * id BC0C6C6B-C6BE-4E96-BFAF-782866BCF8C2
 * name movie-open-edit
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-edit.svg
 * tags
 * - Video / Movie 
 * - Edit / Modify 
 */
export const ClapperboardOpenEditIcon = MovieOpenEditIcon;
export default ClapperboardOpenEditIcon